module.exports = __webpack_public_path__ + "static/media/HomeFurnishing1.701084af.png";